import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';


import { AppComponent } from './app.component';
import { HomeComponent } from '../components/home/home.component';
import { ContactComponent } from '../components/contact/contact.component';
import { LoginComponent} from '../components/login/login.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularFireModule } from 'angularfire2';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { environment } from '../environments/environment';
import { AuthenticationService } from '../providers/authentication.service';
import { DatabaseService } from '../providers/database.service';
import { FooterComponent } from '../components/footer/footer.component';
import { SliderComponent } from '../components/home/slider/slider.component';
import { AccrocheComponent } from '../components/home/accroche/accroche.component';
import { AgmCoreModule } from '@agm/core';
import { AdminComponent } from '../components/admin/admin.component';
import { AccountComponent } from '../components/account/account.component';
import { HeaderComponent } from '../components/header/header.component';
import 'firebase/storage';
import { ResetPasswordComponent } from '../components/reset-password/reset-password.component';
import { FicheComponent } from '../components/admin/fiche/fiche.component';

export const routes: Routes = [
  { path: 'contact', component: ContactComponent },
  { path: 'home', component: HomeComponent },
  { path: 'admin', component: AdminComponent },
  { path: 'reset', component: ResetPasswordComponent },
  { path: 'login/:page', component: LoginComponent },
  { path: 'fiche/:uid', component: FicheComponent },
  { path: 'account', component: AccountComponent },
  { path: '',   redirectTo: 'home', pathMatch: 'full' },
  { path: '**', component: HomeComponent }
];

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ContactComponent,
    LoginComponent,
    FooterComponent,
    SliderComponent,
    AccrocheComponent,
    AdminComponent,
    AccountComponent,
    HeaderComponent,
    ResetPasswordComponent,
    FicheComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(routes),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    AngularFireAuthModule,
    FormsModule,
    ReactiveFormsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCYHU4-Zpc11XlyPxESqKxIPBcytRYqUGA'
    })
  ],
  providers: [
    AuthenticationService,
    DatabaseService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/Mustafa/Developpement/noxoe/src/app/app.module.ts